import React from 'react'
import styled from 'styled-components'
import {
  Image,
  StyleProp,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native'
import { ARROW_LEFT_ICON, PROFILE_IMG_PLACEHOLDER_IMAGE } from 'image/icon'
import { navigation } from 'navigation/global'
import { Body1, Body3, Caption, H2, OverLine } from 'ui/common/text'
import { ColumnLayout, RowLayout } from 'ui/common/layout'
import { colors } from 'infra/color'
import { Place } from 'infra/type'
import { PreferenceButtonArea } from 'ui/common/preference-button-area.tsx'
import { categoryStore } from 'store/category'
import { getSecureImageUrl } from 'infra/util'

const Container = styled(RowLayout)`
  align-items: center;
  background-color: ${colors.white};
`

const BackButton = styled(TouchableOpacity)`
  padding: 16px;
`

const BackButtonIcon = styled(Image)`
  width: 26px;
  height: 26px;
`

const Title = styled(H2)`
  font-weight: 700;
`

export const TopNavigationBar: React.FCC<{
  title: string
  hideBackButton?: boolean
  containerStyle?: StyleProp<ViewStyle>
}> = ({ title, hideBackButton, containerStyle, children }) => {
  return (
    <Container style={containerStyle}>
      {!hideBackButton && (
        <BackButton onPress={navigation.goBack}>
          <BackButtonIcon source={ARROW_LEFT_ICON} />
        </BackButton>
      )}
      <Title>{title}</Title>
      {children}
    </Container>
  )
}

export const PlaceDetailTopNavigationBar: React.FC<{
  place: Place
}> = ({ place }) => {
  return (
    <Container
      style={{
        paddingVertical: 4,
        backgroundColor: colors.gray.v100,
      }}
    >
      <ColumnLayout>
        <BackButton onPress={navigation.goBack}>
          <BackButtonIcon source={ARROW_LEFT_ICON} />
        </BackButton>
      </ColumnLayout>
      <TouchableOpacity
        onPress={() => {
          navigation.navigate('PlaceEditScreen', { place })
        }}
      >
        <ColumnLayout>
          <RowLayout
            style={{
              marginVertical: 2,
              alignItems: 'center',
            }}
          >
            <Body1
              style={{
                fontWeight: 700,
                color: colors.gray.v800,
                marginRight: 6,
              }}
            >
              {place.name}
            </Body1>
            <Body3
              style={{
                color: colors.gray.v500,
              }}
            >
              수정
            </Body3>
            <View style={{ width: 8 }} />
          </RowLayout>
          <Caption style={{ color: colors.gray.v600 }}>
            {categoryStore.formatCategoryIds(place.categories)}
          </Caption>
        </ColumnLayout>
      </TouchableOpacity>
      <RowLayout
        style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center' }}
      >
        <TouchableOpacity
          style={{ paddingHorizontal: 4, paddingVertical: 8, marginRight: 8 }}
          onPress={() => {
            if (place.reportedBy?.id) {
              navigation.navigate('UserDetailScreen', {
                userId: place.reportedBy.id,
              })
            }
          }}
        >
          <ColumnLayout style={{ alignItems: 'center', gap: 4 }}>
            <Image
              source={
                place.reportedBy?.thumbnailImageUrl
                  ? {
                      uri: getSecureImageUrl(
                        place.reportedBy.thumbnailImageUrl,
                      ),
                    }
                  : PROFILE_IMG_PLACEHOLDER_IMAGE
              }
              style={{ width: 16, height: 16, borderRadius: 16 }}
            />
            <OverLine>제보자</OverLine>
          </ColumnLayout>
        </TouchableOpacity>
        <PreferenceButtonArea data={place} isNavigationBar />
        <View style={{ width: 12 }} />
      </RowLayout>
    </Container>
  )
}
